<fieldset>
  <div *ngIf="title" class="title-container">
    <legend class="title">
      {{title}}
    </legend>
  </div>
  <ng-content></ng-content>
  <mat-divider *ngIf="divider" class="divider" inset></mat-divider>
</fieldset>
